// Keep in sync with Padding.java in cos-renderer
const VALUES = {
  NONE: 0,
  HALF: 10,
  FULL: 20
};
export default VALUES;